module.exports = __webpack_public_path__ + "static/media/carnet.bdd7779b.png";